/**
 * A class represents a specific employee rank being assigned to them.
 */
import { EmployeeRankEnum } from '../../enums/EmployeeRankEnum';

export class EmployeeRank {
  rank: EmployeeRankEnum;
  startDate: string;

  /**
   * @param rank the rank of the employee.
   * @param startDate the Monday at which this employee rank takes effect.
   */
  constructor(rank: EmployeeRankEnum, startDate: string) {
    this.rank = rank;
    this.startDate = startDate;
  }
}
